import { languageService } from "../../../Language/language.service";
import { showLabel } from "../../../libraries/form/formField/fields/utilities/showLabel";
import { findTreeNode, treeToPropertiesObject } from "../../../utils/treeData";
import { genericMpMarkerField } from "./AddMaintenanceV2";
import { maintenanceSchemaMPFields, maintenanceSchemaMarkerFields } from "./workOrderSchema";
import _ from "lodash";
export const maintenanceFormMethod = {
  loadDefaultState: (props) => {
    const { priorityList } = props;
    if (priorityList) {
      let def = priorityList.find((p) => p.default === true);
      if (def) {
        return { priority: def.priority, maintenanceType: "other", chargeCode: "other" };
      }
    }
    return { priority: "Pending", maintenanceType: "other", chargeCode: "other" };
  },
  loadAddEditModelState: (modal, modelState, selectedMaintenance) => {
    if (!modal || !modelState === "Edit" || !selectedMaintenance) return modelState; // model should be open, it should be in edit mode and maintenance should be selected, otherwise it can be new or close model state
    if (selectedMaintenance.status !== "New" && selectedMaintenance.status !== "Planned") return "not-new"; // already in progress or completed/closed maintenance should not be editable
    if (["manual-app-workorder", "app-issue"].includes(selectedMaintenance.sourceType)) return "app-edit"; // if from mobile app only specific fields allowed to edit
    return "web-edit"; // if edit and selected but new and not from mobile, means its from web generated.
  },

  loadLocationOptions: (locations = []) => {
    let loc = locations.sort((a, b) => (a.unitId || "").trim().localeCompare((b.unitId || "").trim()));
    return [{ text: "Select", val: "" }, ...loc.map((item) => ({ val: item._id, text: item.unitId }))];
  },
  loadAssetOptions: (lineAssets = []) => {
    if (!lineAssets) return [{ text: "Select", val: "" }];
    let assets = lineAssets.sort((a, b) => (a.unitId || "").trim().localeCompare((b.unitId || "").trim()));
    return [
      { text: "Select", val: "" },
      ...assets.map((asset, index) => ({
        val: asset._id,
        text: asset.unitId,
      })),
    ];
  },
  loadMaintenanceType: (maintenanceTypes) => [...maintenanceTypes.map((mt) => ({ val: mt, text: mt }))],
  loadChargeCodes: (chargeCodes) => [{ val: "", text: "Select" }, ...chargeCodes.map((cc) => ({ val: cc, text: cc }))],
  loadPriorityList: (priorityList) => [...priorityList.map((l) => ({ val: l.priority, text: l.priority }))],
  getAssetsListForLineId: (lineId, assetsTree) => {
    if (assetsTree) {
      let lineBranch = findTreeNode(assetsTree, lineId);
      let assetNodes = treeToPropertiesObject(lineBranch);
      let inspectableAssets = assetNodes.filter((item) => item && item.location === false);
      return inspectableAssets;
    }
    return [];
  },
  getMpMarkerSectionOnAssetChange: (assetId, assets, assetTypes) => {
    let schemaFields = [];
    let customComp = null;
    if (!assets) return;
    let asset = assets.find((a) => a._id === assetId);
    if (!asset) return;
    let yardMarkers = assetTypes && assetTypes.find((aType) => aType.markerMilepost && asset.assetType === aType.assetType);
    if (yardMarkers)
      customComp =
        asset.markerStart || asset.markerEnd
          ? maintenanceFormMethod.getFixedMarkerFields(asset)
          : maintenanceFormMethod.getFixedMpFields(asset);
    else if (asset.assetTypeClassify === "point") customComp = maintenanceFormMethod.getFixedMpFields(asset);
    else schemaFields = maintenanceFormMethod.getLinearAssetMPFields(asset, yardMarkers);
    return { schemaFields: schemaFields, customComp: customComp };
  },
  getFixedMpFields: (asset) => {
    return {
      position: "body",
      sectionPosition: "start",
      sectionId: "MaintenanceLocInfo",
      customComp: [
        genericMpMarkerField("startMp", languageService("Start"), asset.start, true),
        genericMpMarkerField("endMp", languageService("End"), asset.end, true),
      ],
    };
  },
  getFixedMarkerFields: (asset) => {
    return {
      position: "body",
      sectionPosition: "start",
      sectionId: "MaintenanceLocInfo",
      customComp: [
        genericMpMarkerField("markerStart", "Marker Start", asset.markerStart || "N/A", true),
        genericMpMarkerField("markerEnd", "Marker End", asset.markerEnd || "N/A", true),
      ],
    };
  },
  getLinearAssetMPFields: (asset, yardMarkers) => {
    if (!asset || asset.assetTypeClassify !== "linear" || yardMarkers) return [];
    let commonSchema = { disabled: false, subType: "number", title: "" };
    let labelSuffix = ` [${asset.start} to ${asset.end}]`;
    let rangeValidation = {
      minValue: parseFloat(asset.start),
      minValueMessage: `Value should be between ${asset.start} to ${asset.end}`,
      maxValue: parseFloat(asset.end),
      maxValueMessage: `Value should be between ${asset.start} to ${asset.end}`,
    };
    let startMp = {
      ...maintenanceSchemaMPFields[0],
      ...commonSchema,
      labelValueExtension: labelSuffix,
      ...rangeValidation,
    };
    let endMp = { ...maintenanceSchemaMPFields[1], ...commonSchema, labelValueExtension: labelSuffix, ...rangeValidation };
    return [startMp, endMp];
  },

  setCustomSectionFormFields: (customSectionState, newCustomSection) => {
    let finalCustomSectionState = [...customSectionState];
    if (!newCustomSection) return finalCustomSectionState.filter((sc) => sc.sectionId !== "MaintenanceLocInfo");
    let existIndex = finalCustomSectionState.findIndex((sc) => sc.sectionId === "MaintenanceLocInfo");
    if (existIndex === -1) {
      finalCustomSectionState.push(newCustomSection);
    } else {
      finalCustomSectionState[existIndex] = newCustomSection;
    }
    return finalCustomSectionState;
  },

  unHideFDOTBasedOnFormState: (MschemaFields, FormState) => {
    const fieldsCopy = _.cloneDeep(MschemaFields);
    if (FormState === "Add") return fieldsCopy;
    const fdotIndex = fieldsCopy.findIndex((field) => field.id === "fdotId");
    if (fdotIndex !== -1) {
      fieldsCopy[fdotIndex].hide = false;
    }
    return fieldsCopy;
  },
  updateMaintenanceTypeFieldForRevamp: (Schema) => {
    const fieldsCopy = _.cloneDeep(Schema);
    const maintenanceTypeIndex = fieldsCopy.findIndex((field) => field.id === "maintenanceType");
    if (maintenanceTypeIndex !== -1) {
      let label = languageService("Maintenance Type");
      fieldsCopy[maintenanceTypeIndex].labelValue = label;
    }
    return fieldsCopy;
  },
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenanceV2/maintenanceFormMethods.js